import { style } from '@vanilla-extract/css';
import {
  fontSizeVars,
  fontWeightVars,
  spacingVars,
} from '@tundr/ds-foundations';
import { semanticTokenVars } from '@tundr/ds-tokens';

export const breadCrumbItemContainerClass = style({
  display: 'flex',
  alignItems: 'center',
  marginRight: spacingVars.md,
  gap: spacingVars.md,
});

export const breadCrumbItemTitleClass = style({
  textDecoration: 'none',
  cursor: 'default',
  color: semanticTokenVars.content.subtle.default,
});

export const breadCrumbItemLastTitleClass = style({
  fontWeight: fontWeightVars.bold,
  color: semanticTokenVars.content.default.default,
});

export const itemDividerClass = style({
  fontSize: fontSizeVars.body.body2,
});
